import type { RouteRecordRaw } from 'vue-router';

export const returnsRoutes: Array<RouteRecordRaw> = [
  {
    path: '/returns',
    name: 'returns',
    redirect: '/returns/list',
    component: () => import('pages/trade/admin/returns/McReturns.vue'),
    meta: {
      title: 'Returns',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'returnsList',
        component: () => import('pages/trade/admin/returns/ReturnsList.vue'),
        meta: {
          title: 'Returns List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'returnsDetail',
        component: () => import('pages/trade/admin/returns/ReturnsDetail.vue'),
        meta: {
          title: 'Returns Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'returnsNew',
        component: () => import('pages/trade/admin/returns/ReturnsNew.vue'),
        meta: {
          title: 'New Returns',
          requiresAuth: true,
        },
      },
    ],
  },
];
